import { UnauthorizedPage } from '~/components/auth/UnauthorizedPage'
import { useActiveOrgMember } from '~/hooks/org'

/**
 * This is a higher order component to block users from accessing a page based on org permissions.
 * Should only be used with page components.
 */
export const withOrgAccess = <P extends object>(
  Component: React.ComponentType<P>,
  options: {
    requireOwner?: boolean
  },
) => {
  const WrappedComponent = (props: P) => {
    const orgMember = useActiveOrgMember()
    const hasAccess = options?.requireOwner ? orgMember?.role === 'OWNER' : true

    if (!hasAccess) {
      return (
        <UnauthorizedPage customMessage="This page is restricted to owners of this workspace. Please verify the selected workspace and that you are an owner." />
      )
    }

    return <Component {...props} />
  }

  WrappedComponent.displayName = `withOrgAccess(${
    Component.displayName || Component.name || 'Component'
  })`

  return WrappedComponent
}
